import { render, staticRenderFns } from "./ProjectManagementRemarks.vue?vue&type=template&id=5c79f9a8&"
import script from "./ProjectManagementRemarks.vue?vue&type=script&lang=js&"
export * from "./ProjectManagementRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports